<template>
  <div class="view">
    <div class="title">
      <i class="goback el-icon-arrow-left" @click="goback"></i>
      {{titleinfo}}
    </div>
    <div class="content">
   
      <div class="set_flexwrap">
        
        <div class="flex_wrap">
          <el-steps :active="active" finish-status="success">
            <el-step title="填写主体信息"></el-step>
            <el-step title="填写小程序信息"></el-step>
            <el-step title="上传资料"></el-step>
          </el-steps>
   
          <el-form ref="form" :rules="rules" :model="formdata" label-width="120px" v-if="active == 0">
            <div class="form_splititem">基本信息</div>
            <el-form-item label="主体性质" prop="mainType">
              <el-select v-model="formdata.mainType" class="w160" placeholder="请选择">
                <el-option
                        v-for="item in mainTypeData"
                        :key="item.type"
                        :label="item.name"
                        :value="item.type"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="主办单位名称" prop="goods_name">
              <el-input type="text" v-model="formdata.goods_name" maxlength="30" ></el-input>
            </el-form-item>
            <el-form-item label="省市区"  prop="distructvalue">
              <el-cascader
              v-model="formdata.distructvalue"
              :options="districtData"
              :props="{ expandTrigger: 'hover',children:'sub_list', value:'code',label:'name'}"
              @change="handleDistrictChange"></el-cascader>
            </el-form-item>
            <el-form-item label="通讯地址" prop="address">
              <el-input type="text" v-model="formdata.address" maxlength="30" ></el-input>
            </el-form-item>
            <el-form-item label="信息备注" prop="comment">
              <el-input type="text" v-model="formdata.comment" maxlength="30" ></el-input>
            </el-form-item>
            <div class="form_splititem">个人主体额外信息</div>
            <el-form-item class="whd-form-item" label="临时居住证照片" prop="residence_permit">
              <uploaddrag v-if="formdata.residence_permit"
                      :picture="formdata.residence_permit"
                      filed="icp_subject.personal_info.residence_permit"
                      filefname="residence_permit"
                      mediatype="image"
                      @uploadsucess="uploadresidence"
                      @uploadmediasucess="uploadmediasucess"
                      limit="1"
                      ref="pictures"
              >
                <div slot="tipinfo" class="el-upload__tip">
                  个人备案且非本省人员，需要提供居住证、暂住证、社保证明、房产证等临时居住证明，可以拖拽图片调整顺序，最多上传1张，
                  图片宽高均不超过4000，宽不低于640,宽高比不超过1:25，单张不超过10M
                </div>
              </uploaddrag>
            </el-form-item>
            <div class="form_splititem">主体额外信息 (个人备案时，如果存在与主体负责人信息相同的字段，则填入相同的值)</div>
            <el-form-item label="证件类型" prop="certificate_type">
              <el-select v-model="formdata.certificate_type" class="w160" placeholder="请选择">
                <el-option
                        v-for="item in certificateData"
                        :key="item.type"
                        :label="item.name"
                        :value="item.type"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="证件号码" prop="certificate_number">
              <el-input type="text" v-model="formdata.certificate_number" maxlength="30" ></el-input>
            </el-form-item>
            <el-form-item label="证件住所" prop="certificate_address">
              <el-input type="text" v-model="formdata.certificate_address" maxlength="30" ></el-input>
            </el-form-item>
            <el-form-item class="whd-form-item" label="证件照片" prop="certificate_photo" v-if="formdata.certificate_type">
              <uploaddrag v-if="formdata.certificate_photo"
                      :picture="formdata.certificate_photo"
                      filed="icp_subject.organize_info.certificate_photo"
                      filefname="certificate_photo"
                      :certificateType="formdata.certificate_type"
                      mediatype="image"
                      @uploadsucess="uploadresidence"
                      @uploadmediasucess="uploadmediasucess"
                      limit="1"
                      ref="pictures"
              >
                <div slot="tipinfo" class="el-upload__tip">
                  (主体为非个人类型，则必填)
                </div>
              </uploaddrag>
            </el-form-item>
           
            <div class="form_splititem">主体负责人信息</div>
            <el-form-item label="姓名" prop="realname">
              <el-input type="text" v-model="formdata.realname" maxlength="30" ></el-input>
            </el-form-item>
            <el-form-item label="联系方式" prop="mobile">
              <el-input type="text" v-model="formdata.mobile" maxlength="30" ></el-input>
            </el-form-item>
            <el-form-item label="证件号码" prop="fuze_certificate_number">
              <el-input type="text" v-model="formdata.fuze_certificate_number" maxlength="30" ></el-input>
            </el-form-item>
            <el-form-item label="证件类型" prop="zt_certificate_type">
              <el-select v-model="formdata.zt_certificate_type" class="w160" placeholder="请选择">
                <el-option
                        v-for="item in certificateData"
                        :key="item.type"
                        :label="item.name"
                        :value="item.type"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="电子邮件" prop="email">
              <el-input type="text" v-model="formdata.email" maxlength="30" ></el-input>
            </el-form-item>
            <el-form-item label="应急联系方式" prop="emergency_contact">
              <el-input type="text" v-model="formdata.emergency_contact" maxlength="30" ></el-input>
            </el-form-item>
            <el-form-item label="证件有效期" prop="finishtime" >
              <el-date-picker
                v-model="formdata.finishtime"
                type="daterange"
                range-separator="-"
                start-placeholder="开始日期"
                unlink-panels
                end-placeholder="结束日期"
                size="small"
                format="yyyyMMdd"
                value-format="yyyyMMdd"
                :picker-options="pickerOptions1"
              ></el-date-picker>
            </el-form-item>
            <el-form-item class="whd-form-item" label="证件正面照片" prop="certificate_photo_front" v-if="formdata.zt_certificate_type">
              <uploaddrag v-if="formdata.certificate_photo_front"
                      :picture="formdata.certificate_photo_front"
                      filed="icp_subject.principal_info.certificate_photo_front"
                      filefname="certificate_photo_front"
                      :certificateType="formdata.zt_certificate_type"
                      mediatype="image"
                      @uploadsucess="uploadresidence"
                      @uploadmediasucess="uploadmediasucess"
                      limit="1"
                      ref="pictures"
              >
                <div slot="tipinfo" class="el-upload__tip">
                </div>
              </uploaddrag>
            </el-form-item>
            <el-form-item class="whd-form-item" label="证件背面照片" prop="certificate_photo_back" v-if="formdata.zt_certificate_type">
              <uploaddrag v-if="formdata.certificate_photo_back"
                      :picture="formdata.certificate_photo_back"
                      filed="icp_subject.principal_info.certificate_photo_back"
                      filefname="certificate_photo_back"
                      :certificateType="formdata.zt_certificate_type"
                      mediatype="image"
                      @uploadsucess="uploadresidence"
                      @uploadmediasucess="uploadmediasucess"
                      limit="1"
                      ref="pictures"
              >
                <div slot="tipinfo" class="el-upload__tip">
                </div>
              </uploaddrag>
            </el-form-item>
            <el-form-item class="whd-form-item" label="授权书" prop="authorization_letter">
              <uploaddrag v-if="formdata.authorization_letter"
                      :picture="formdata.authorization_letter"
                      filed="icp_applets.principal_info.authorization_letter"
                      filefname="authorization_letter"
                      mediatype="image"
                      @uploadsucess="uploadresidence"
                      @uploadmediasucess="uploadmediasucess"
                      limit="1"
                      ref="pictures"
              >
                <div slot="tipinfo" class="el-upload__tip">
                  主体负责人非法人时上传
                </div>
              </uploaddrag>
            </el-form-item>
            <div class="form_splititem">法人信息(非个人备案，且主体负责人不是法人时，必填)</div>
            <el-form-item label="法人代表姓名" prop="faren_name">
              <el-input type="text" v-model="formdata.faren_name" maxlength="30" ></el-input>
            </el-form-item>
            <el-form-item label="法人证件号码" prop="faren_certificate_number">
              <el-input type="text" v-model="formdata.faren_certificate_number" maxlength="30" ></el-input>
            </el-form-item>
            <el-form-item>
              <el-button style="margin-top: 12px;" @click="top()" v-if="active != 0" size="small">上一步</el-button>
              <el-button style="margin-top: 12px;" @click="next('form')" v-if="active != 2" size="small">下一步</el-button>
              <el-button @click="goback" size="small">取消</el-button>
            </el-form-item>
            </el-form>

            <!-- //=============================== -->
            <el-form ref="form1" :rules="radio == 1?rules:rules1" :model="formdata" label-width="120px"  v-if="active == 1">
            <div class="form_splititem">小程序信息</div>
            <el-form-item label="前置审批号">
              <el-input type="text" v-model="formdata.nrlx_code" maxlength="30" ></el-input>
            </el-form-item>
            <el-form-item class="whd-form-item" label="前置审批媒体材料" prop="nrlx_media">
              <uploaddrag v-if="formdata.nrlx_media"
                      :picture="formdata.nrlx_media"
                      filed="icp_subject.base_info.nrlx_details.media"
                      filefname="nrlx_media"
                      mediatype="image"
                      @uploadsucess="uploadresidence"
                      @uploadmediasucess="uploadmediasucess"
                      limit="1"
                      ref="pictures"
              >
                <div slot="tipinfo" class="el-upload__tip">
                </div>
              </uploaddrag>
            </el-form-item>
            <el-form-item label="前置审批类型"  prop="nrlx_type">
              <el-select v-model="formdata.nrlx_type" class="w160" placeholder="请选择">
                <el-option
                        v-for="item in nrlx_typeData"
                        :key="item.type"
                        :label="item.name"
                        :value="item.type"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="小程序服务内容类型" prop="service_content_types">
              <el-select v-model="formdata.service_content_types" multiple :multiple-limit=5  class="w160" placeholder="请选择">
                <el-option
                        v-for="item in server_typeData"
                        :key="item.type"
                        :label="item.name"
                        :value="item.type"
                ></el-option>
              </el-select>
              <div  class="el-upload__tip">
                最多5个
              </div>
            </el-form-item>
            <el-form-item label="信息备注" prop="xcx_comment">
              <el-input type="text" v-model="formdata.xcx_comment" maxlength="200" ></el-input>
            </el-form-item>
             
            <div class="form_splititem">小程序负责人信息</div>
            <div style="margin-bottom: 20px;">
              <template>
                <el-radio-group v-model="radio">
                  <el-radio :label="1" value="1">复用主体负责人信息</el-radio>
                  <el-radio :label="2" value="2">手动填写</el-radio>
                </el-radio-group>
              </template>
            </div>
            <div  v-if="radio == 2">
            <el-form-item label="姓名" prop="xcx_realname">
              <el-input type="text" v-model="formdata.xcx_realname" maxlength="30" ></el-input>
            </el-form-item>
            <el-form-item label="联系方式" prop="xcx_mobile">
              <el-input type="text" v-model="formdata.xcx_mobile" maxlength="30" ></el-input>
            </el-form-item>
            <el-form-item label="证件号码" prop="xcx_fuze_certificate_number">
              <el-input type="text" v-model="formdata.xcx_fuze_certificate_number" maxlength="30" ></el-input>
            </el-form-item>
            <el-form-item label="证件类型" prop="xcx_certificate_type">
              <el-select v-model="formdata.xcx_certificate_type" class="w160" placeholder="请选择">
                <el-option
                        v-for="item in certificateData"
                        :key="item.type"
                        :label="item.name"
                        :value="item.type"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="电子邮件" prop="xcx_email">
              <el-input type="text" v-model="formdata.xcx_email" maxlength="30" ></el-input>
            </el-form-item>
            <el-form-item label="应急联系方式" prop="xcx_emergency_contact">
              <el-input type="text" v-model="formdata.xcx_emergency_contact" maxlength="30" ></el-input>
            </el-form-item>
            <el-form-item label="证件有效期" prop="xcx_finishtime" >
              <el-date-picker
                v-model="formdata.xcx_finishtime"
                type="daterange"
                range-separator="-"
                start-placeholder="开始日期"
                unlink-panels
                end-placeholder="结束日期"
                size="small"
                format="yyyyMMdd"
                value-format="yyyyMMdd"
                :picker-options="pickerOptions1"
              ></el-date-picker>
            </el-form-item>
            <el-form-item class="whd-form-item" label="证件正面照片"  prop="xcx_certificate_photo_front"  v-if="formdata.xcx_certificate_type">
              <uploaddrag v-if="formdata.xcx_certificate_photo_front"
                      :picture="formdata.xcx_certificate_photo_front"
                      filed="icp_applets.principal_info.certificate_photo_front"
                      filefname="xcx_certificate_photo_front"
                      :certificateType="formdata.xcx_certificate_type"
                      mediatype="image"
                      @uploadsucess="uploadresidence"
                      @uploadmediasucess="uploadmediasucess"
                      limit="1"
                      ref="pictures"
              >
                <div slot="tipinfo" class="el-upload__tip">
                 
                </div>
              </uploaddrag>
            </el-form-item>
            <el-form-item class="whd-form-item" label="证件背面照片" prop="xcx_certificate_photo_back" v-if="formdata.xcx_certificate_type">
              <uploaddrag v-if="formdata.xcx_certificate_photo_back"
                      :picture="formdata.xcx_certificate_photo_back"
                      filed="icp_applets.principal_info.certificate_photo_back"
                      filefname="xcx_certificate_photo_back"
                      :certificateType="formdata.xcx_certificate_type"
                      mediatype="image"
                      @uploadsucess="uploadresidence"
                      @uploadmediasucess="uploadmediasucess"
                      limit="1"
                      ref="pictures"
              >
                <div slot="tipinfo" class="el-upload__tip">
                </div>
              </uploaddrag>
            </el-form-item>
            <el-form-item class="whd-form-item" label="授权书" prop="xcx_authorization_letter">
              <uploaddrag v-if="formdata.xcx_authorization_letter"
                      :picture="formdata.xcx_authorization_letter"
                      filed="icp_applets.principal_info.authorization_letter"
                      filefname="xcx_authorization_letter"
                      mediatype="image"
                      @uploadsucess="uploadresidence"
                      @uploadmediasucess="uploadmediasucess"
                      limit="1"
                      ref="pictures"
              >
                <div slot="tipinfo" class="el-upload__tip">
                  小程序负责人不是法人时需要小程序负责人授权书
                </div>
              </uploaddrag>
            </el-form-item>
          </div>
            <el-form-item>
              <el-button style="margin-top: 12px;" @click="top()" v-if="active != 0" size="small">上一步</el-button>
              <el-button style="margin-top: 12px;" @click="next('form1')" v-if="active != 2" size="small">下一步</el-button>
              <el-button @click="goback" size="small">取消</el-button>
            </el-form-item>
            </el-form>


            <!-- //=============================== -->
            <el-form ref="form2" :rules="rules" :model="formdata" label-width="120px"  v-if="active == 2">
            <div class="form_splititem">其他备案媒体材料</div>
            <el-form-item class="whd-form-item" label="互联网信息服务承诺书" prop="commitment_letter">
              <uploaddrag v-if="formdata.commitment_letter"
                      :picture="formdata.commitment_letter"
                      filed="icp_materials.commitment_letter"
                      filefname="commitment_letter"
                      mediatype="image"
                      @uploadsucess="uploadresidence"
                      @uploadmediasucess="uploadmediasucess"
                      limit="1"
                      ref="pictures"
              >
                <div slot="tipinfo" class="el-upload__tip">
                </div>
              </uploaddrag>
            </el-form-item>
            <el-form-item class="whd-form-item" label="主体更名函" prop="business_name_change_letter">
              <uploaddrag v-if="formdata.business_name_change_letter"
                      :picture="formdata.business_name_change_letter"
                      filed="icp_materials.business_name_change_letter"
                      filefname="business_name_change_letter"
                      mediatype="image"
                      @uploadsucess="uploadresidence"
                      @uploadmediasucess="uploadmediasucess"
                      limit="1"
                      ref="pictures"
              >
                <div slot="tipinfo" class="el-upload__tip">
                </div>
              </uploaddrag>
            </el-form-item>
            <el-form-item class="whd-form-item" label="党建确认函" prop="party_building_confirmation_letter">
              <uploaddrag v-if="formdata.party_building_confirmation_letter"
                      :picture="formdata.party_building_confirmation_letter"
                      filed="icp_materials.party_building_confirmation_letter"
                      filefname="party_building_confirmation_letter"
                      mediatype="image"
                      @uploadsucess="uploadresidence"
                      @uploadmediasucess="uploadmediasucess"
                      limit="1"
                      ref="pictures"
                      @click="bindUpload('11111',$event)"
              >
                <div slot="tipinfo" class="el-upload__tip">
                </div>
              </uploaddrag>
            </el-form-item>
            <el-form-item label="承诺视频">
              <el-upload
                      class="addicon"
                      :action="uploadvideourl"
                      :data="data_"
                      :show-file-list="false"
                      :limit="1"
                      :on-success="handlepromise_videoSuccess"
                      :before-upload="beforevideoUpload"
              >
                 <div v-if="formdata.promise_video!==''">
                   <video
                           :src="formdata.promise_video"
                           class="avatar"
                           controls="controls"
                   >您的浏览器不支持视频播放
                   </video>
                   <span class="detelBox" @click.stop="handlevideoRemove">删除</span>
                 </div>
                <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                <div
                        slot="tip"
                        class="el-upload__tip"
                >
                </div>
              </el-upload>
            </el-form-item>
            <el-form-item class="whd-form-item" label="网站备案信息真实性责任告知书" prop="authenticity_responsibility_letter">
              <uploaddrag v-if="formdata.authenticity_responsibility_letter"
                      :picture="formdata.authenticity_responsibility_letter"
                      filed="icp_materials.authenticity_responsibility_letter"
                      filefname="authenticity_responsibility_letter"
                      mediatype="image"
                      @uploadsucess="uploadresidence"
                      @uploadmediasucess="uploadmediasucess"
                      limit="1"
                      ref="pictures"
              >
                <div slot="tipinfo" class="el-upload__tip">
                </div>
              </uploaddrag>
            </el-form-item>
            <el-form-item class="whd-form-item" label="小程序备案信息真实性承诺书" prop="authenticity_commitment_letter">
              <uploaddrag v-if="formdata.authenticity_commitment_letter"
                      :picture="formdata.authenticity_commitment_letter"
                      filed="icp_materials.authenticity_commitment_letter"
                      filefname="authenticity_commitment_letter"
                      mediatype="image"
                      @uploadsucess="uploadresidence"
                      @uploadmediasucess="uploadmediasucess"
                      limit="1"
                      ref="pictures"
              >
                <div slot="tipinfo" class="el-upload__tip">
                </div>
              </uploaddrag>
            </el-form-item>
            <el-form-item class="whd-form-item" label="小程序建设方案书" prop="website_construction_proposal">
              <uploaddrag v-if="formdata.website_construction_proposal"
                      :picture="formdata.website_construction_proposal"
                      filed="icp_materials.website_construction_proposal"
                      filefname="website_construction_proposal"
                      mediatype="image"
                      @uploadsucess="uploadresidence"
                      @uploadmediasucess="uploadmediasucess"
                      limit="1"
                      ref="pictures"
              >
                <div slot="tipinfo" class="el-upload__tip">
                </div>
              </uploaddrag>
            </el-form-item>
            <el-form-item class="whd-form-item" label="主体其它附件" prop="subject_other_materials">
              <uploaddrag v-if="formdata.subject_other_materials"
                      :picture="formdata.subject_other_materials"
                      filed="icp_materials.subject_other_materials"
                      filefname="subject_other_materials"
                      mediatype="image"
                      @uploadsucess="uploadresidence"
                      @uploadmediasucess="uploadmediasucess"
                      @deleteMediaUpload="deleteMediaUpload"
                      limit="10"
                      ref="pictures"
              >
                <div slot="tipinfo" class="el-upload__tip">
                  最多上传10个
                </div>
              </uploaddrag>
            </el-form-item>
            <el-form-item class="whd-form-item" label="小程序其它附件" prop="applets_other_materials">
              <uploaddrag v-if="formdata.applets_other_materials"
                      :picture="formdata.applets_other_materials"
                      filed="icp_materials.applets_other_materials"
                      filefname="applets_other_materials"
                      mediatype="image"
                      @uploadsucess="uploadresidence"
                      @uploadmediasucess="uploadmediasucess"
                      @deleteMediaUpload="deleteMediaUpload"
                      limit="10"
                      ref="pictures"
              >
                <div slot="tipinfo" class="el-upload__tip">
                  最多上传10个
                </div>
              </uploaddrag>
            </el-form-item>
            <el-form-item class="whd-form-item" label="手持证件照" prop="holding_certificate_photo">
              <uploaddrag v-if="formdata.holding_certificate_photo"
                      :picture="formdata.holding_certificate_photo"
                      filed="icp_materials.holding_certificate_photo"
                      filefname="holding_certificate_photo"
                      mediatype="image"
                      @uploadsucess="uploadresidence"
                      @uploadmediasucess="uploadmediasucess"
                      limit="1"
                      ref="pictures"
              >
                <div slot="tipinfo" class="el-upload__tip">
                </div>
              </uploaddrag>
            </el-form-item>
            <!-- <el-form-item label="产品图片" prop="album">
              <div v-if="formdata.album.length>0">
                <draggable v-model="formdata.album" :options="{draggable:'.draggableItem',animation: 150}"
                            :move="getdata"
                           @update="datadragEnd" class="draggable-body-list whd-draggable-list">
                  <transition-group class="draggable-body">
                    <div v-for="(item,index) in formdata.album" :key="item" class="draggableItem" 
                         :style="{backgroundImage:'url('+item+')',backgroundSize:'cover',backgroundPosition:'center'}"
                         :class="currentindex==index?'activedraggable':''" @click.stop="indexLine(index)">
                      <i class="el-icon-circle-close" @click="detelFn(index)"></i>
                    </div>
                  </transition-group>
                </draggable>
              </div>
              <div class="addicon">
                <div class="el-upload el-upload--text" @click="showCropper">
                  <i class="el-icon-plus avatar-uploader-icon"></i>
                </div>
                <div class="el-upload__tip">第一张默认为封面,可以拖拽图片调整顺序，最多上传5张，尺寸640*640比例，大小10M以内。</div>
              </div>              
            </el-form-item> -->
            <!-- <el-form-item label="介绍视频">
              <el-upload
                      class="addicon"
                      :action="uploadvideourl"
                      :data="data_"
                      :show-file-list="false"
                      :limit="1"
                      :on-success="handlevideoSuccess"
                      :before-upload="beforevideoUpload"
              >
                 <div v-if="formdata.video!==''">
                   <video
                           :src="formdata.video"
                           class="avatar"
                           controls="controls"
                   >您的浏览器不支持视频播放
                   </video>
                   <span class="detelBox" @click.stop="handlevideoRemove">删除</span>
                 </div>
                <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                <div
                        slot="tip"
                        class="el-upload__tip"
                >介绍视频默认放在商品主图中第一屏，如有需要请上传，最多上传一个（仅支持5M以内的MP4格式）
                </div>
              </el-upload>
            </el-form-item> -->
            <!-- <el-form-item class="whd-form-item" label="产品详情图片" prop="goods_detail">
              <uploaddrag v-if="formdata.goods_detail"
                      :picture="formdata.goods_detail"
                      @uploadsucess="uploaddetail"
                      limit="1"
                      ref="pictures"
              >
                <div slot="tipinfo" class="el-upload__tip">
                  上传与商品详情有关图片，可以拖拽图片调整顺序，最多上传25张，
                  图片宽高均不超过4000，宽不低于640,宽高比不超过1:25，单张不超过10M
                </div>
              </uploaddrag>
            </el-form-item> -->
            <el-form-item>
              <el-button style="margin-top: 12px;" @click="top()" v-if="active != 0" size="small">上一步</el-button>
              <el-button type="primary" @click="savegood('form2')" size="small">保存</el-button>
              <el-button @click="goback" size="small">取消</el-button>
            </el-form-item>
          </el-form>
          <div v-if="msgText">{{'失败原因：'+msgText}}</div>
        </div>
      
      </div>
    </div>
    <corpper :visible.sync="corppervisible"
             v-if="corppervisible" @imgAddBack="imgAddBack" :imgSize="imgSize"></corpper>
    <!-- 暂时注释，待接口调整后开启 -->         
    <!-- <el-drawer  
      title="选择要关联的表单"
      direction="rtl"
      custom-class="custom-drawer"
      :visible.sync="drawer"
      >
        <div style="height: 100%; padding-bottom: 80px; overflow-y: auto">
          <div v-for="(item,index) in formList" :key="index" class="weui-cell" @click="selectForm(item.id, item.title)">
            <div class="weui-cell__hd">
              <i class="el-icon-success" :class="{'on':form_id===item.id}"></i>
            </div>
            <div class="weui-cell__hd">
              <div class="formtableimg">
                <img :src="item.back_img" />
              </div>              
            </div>
            <div class="weui-cell__bd">{{item.title}}</div>
          </div>
          <div class="pag_wrap">
            <el-pagination
              background
              layout="prev, pager, next"
              :page-size="page.pagesize"
              :current-page="page.pageindex"
              :total="page.total"
              @current-change="handleCurrentChange"
            ></el-pagination>
          </div>    
        </div>  
    </el-drawer>              -->
  </div>
</template>
<script>
  import api from "@/api.js";
  import uploaddrag from "@/components/uploaddragicp.vue";
import { Loading, Message } from 'element-ui'; //项目已经全局引入element的话可以不单独引入
  import corpper from "@/components/dialog/corpper.vue";
  import draggable from 'vuedraggable';
  import { pagination } from "@/util/util.js";
  import {
    goodtype,
    issale,
    ishot,
    isrecommend,
    ischeap,
    isnew,
    logisticsset,
    commset,
    commtype,
    isattr,
    ispay,
    showtype,
    shippingset
  } from "@/util/util.js";

  export default {
    name: "addOrEditGoods",
    components: {
      uploaddrag:uploaddrag,
      corpper,
      draggable
    },
    data() {
      return {
        msgText:'',
        radio:1,
        active: 0,
        pickerOptions1:{},
        data_: {token: sessionStorage.getItem("token")},
        imgSize: 0,
        corppervisible: false,
        currentindex: 0,
        titleinfo: "名片小程序授权",
        uploadvideourl: api.uploadRecordTokenVideo,
        goodtype: goodtype,
        issale: issale,
		ishot: ishot,
		isrecommend: isrecommend,
		ischeap: ischeap,
		isnew: isnew,
        logisticsset: logisticsset,
        commset: commset,
        commtype: commtype,
        isattr: isattr,
        ispay: ispay,
        showtype: showtype,
        shippingset: shippingset,
        formdata: { 
          // address:'美食街183号6栋3楼',
          // certificate_address:'福建省泉州市鲤城区鲤中街道促进社区美食街183号6栋三楼',
          // certificate_number:'91350502MA350EP20F',
          // email:'779052955@qq.com',
          // emergency_contact:'15359599911',
          // finishtime:["20070615", "20270615"],
          // mobile:'15359599911',
          // name:'福建省轻影信息科技有限公司',
          // mainType:4,
          // fuze_certificate_number:'350524197803301529',
          // certificate_type:1,
          // zt_certificate_type:'2',
          // nrlx_type:24,
          // realname:'李素治',
          // goods_name: "福建省轻影信息科技有限公司",
          // distructvalue:[350000,350200,350203],

          // service_content_types:[3],
          // xcx_comment:'影楼行业Saas营销是国内人工智能营销工具倡导者，秉承「技术驱动创新，数据重构销售新体验」的理念，为企业沉淀数据资产，全面提升销售效率',
          // xcx_realname:'李素治',
          // xcx_mobile:'15359599911',
          // xcx_email:'779052955@qq.com',
          // xcx_emergency_contact:'15359599911',
          // xcx_certificate_type:'2',
          // xcx_fuze_certificate_number:'350524197803301529',
          // xcx_finishtime:["20070615", "20270615"],
          
          address:'',
          certificate_address:'',
          certificate_number:'',
          faren_certificate_number:'',
          fuze_certificate_number:'',
          email:'',
          emergency_contact:'',
          finishtime:[],
          mobile:'',
          name:'',
          mainType:'',
          certificate_type:'',
          nrlx_type:'',
          realname:'',
          goods_name: "",
          distructvalue:[],
          xcx_comment:'',
          faren_certificate_number:'',
          residence_permitmedia:'',
          certificate_photomedia:'',
          certificate_photo_frontmedia:'',
          certificate_photo_backmedia:'',
          authorization_lettermedia:'',
          xcx_authorization_lettermedia:'',
          commitment_lettermedia:'',
          business_name_change_lettermedia:'',
          party_building_confirmation_lettermedia:'',
          authenticity_responsibility_lettermedia:'',
          authenticity_commitment_lettermedia:'',
          website_construction_proposalmedia:'',
          subject_other_materialsmedia:[],
          applets_other_materialsmedia:[],
          holding_certificate_photomedia:'',
          promise_videomedia:'',
          nrlx_mediamedia:'',
          nrlx_code:'',
          

          comment:'',
   
          type: 0,
  
          // cat_id: [],
          // cat_label: [],
          // album: [],
          video: "",
          promise_video:'',
          goods_detail: [],
          residence_permit:[],
          certificate_photo:[],
          certificate_photo_front:[],
          xcx_certificate_photo_front:[],
          xcx_certificate_photo_back:[],
          xcx_authorization_letter:[],
          certificate_photo_back:[],
          authorization_letter:[],
          commitment_letter:[],
          business_name_change_letter:[],
          party_building_confirmation_letter:[],
          authenticity_responsibility_letter:[],
          authenticity_commitment_letter:[],
          website_construction_proposal:[],
          subject_other_materials:[],
          applets_other_materials:[],
          holding_certificate_photo:[],
          nrlx_media:[],
          applets_other_materialsmedia:[],
          subject_other_materialsmedia:[],
      //     order_desc: "",
      //     is_pay: 0,
      //     is_attr: 0,
      //     unit: "",
      //     cost: "",
      //     shop_price: "",
      //     goods_number: "",
      //     comm_type: 0,
      //     commission: "",
      //     comm_set: 0,
      //     comm_outside: 50,
      //     outside: "",
      //     comm_inside: 50,
      //     inside: "",
      //     logistics_set: 0,
      //     shipping_set: 0,
      //     shipping_fee: "",
      //     fre_id: "",
      //     shipping_name: "",
      //     shipping_phone: "",
      //     is_sale: 0,
      //     finishtime:'',
		  // is_hot: 0,
		  // is_recommend: 0,
		  // is_cheap: 0,
		  // is_new: 0,
      //     show_type: "",
      //     show_price: "",
      //     reference: "",
      //     reference_price: "1万-10万",
      //     reference1: "参考价格",
      //     reference2: "价格面议",
      //     attr_cate: "",
      //     goods_brief: "",
      //     goods_desc: "",
      //     points: "",
      //     false_sales: ""  // 初始化虚拟销量
          
        },
        cateoptions: [],
        freoptions: [],
        mainTypeData:[],
        distructvalue:[],
        certificateData:[],
        districtData:[],
        attrcateoptions: [],
        server_typeData:[],
        nrlx_typeData:[],
        imageUrl: "",
        checkattrList: [],
        attrinfo: [],
        tablehead: [],
        attr_price: "",
        attr_number: "",
        attr_points: "",
        attrtable: [],
        id: "",
        ispayshow: false,
        lock: true,
        attremptycount: 0,
        defaultProps: {
          value: "id",
          label: "name",
          children: "child"
        },
        rules: {
          service_content_types:[{required: true, message: "请选择小程序服务内容", trigger: "blur"}],
          goods_name: [
            {required: true, message: "请输入主办单位名称", trigger: "blur"}
          ],
          mainType: [
            {required: true, message: "请选择主体性质", trigger: "blur"}
          ],
          distructvalue: [
            {required: true, message: "请选择省市区", trigger: "blur"}
          ],
          address: [
            {required: true, message: "请输入通讯地址", trigger: "blur"}
          ],
          certificate_type: [
            {required: true, message: "请选择证件类型", trigger: "blur"}
          ],
          zt_certificate_type: [
            {required: true, message: "请选择证件类型", trigger: "blur"}
          ],
          fuze_certificate_number: [
            {required: true, message: "请选择证件号码", trigger: "blur"}
          ],
          certificate_number: [
            {required: true, message: "请输入证件号码", trigger: "blur"}
          ],
          certificate_address: [
            {required: true, message: "请输入证件住所", trigger: "blur"}
          ],
          certificate_photo: [
            {required: true, message: "请输入证件照片", trigger: "blur"}
          ],
          realname: [
            {required: true, message: "请输入姓名", trigger: "blur"}
          ],
          mobile: [
            {required: true, message: "请输入联系方式", trigger: "blur"}
          ],
          email: [
            {required: true, message: "请输入电子邮箱", trigger: "blur"}
          ],
          emergency_contact: [
            {required: true, message: "请输入应急联系方式", trigger: "blur"}
          ],
          finishtime: [
            {required: true, message: "请输入证件有效期", trigger: "blur"}
          ],
          certificate_photo_front: [
            {required: true, message: "请输入证件正面照片", trigger: "blur"}
          ],
          certificate_photo_back: [
            {required: true, message: "请输入证件背面照片", trigger: "blur"}
          ],
          album: [
            {required: true, message: "请上传产品图片", trigger: "change"}
          ],
          nrlx_type: [
            {required: true, message: "请选择前置审批类型", trigger: "change"}
          ],
          goods_detail: [
            {required: true, message: "请上传产品详情图片", trigger: "change"}
          ],
          unit: [{required: true, message: "请输入销售单位", trigger: "blur"}],
          goods_number: [
            {required: true, message: "请输入库存", trigger: "blur"}
          ],
          attr_cate: [
            {required: true, message: "请选择商品类目", trigger: "change"}
          ],      
          shop_price: [{required: true, message: "请输入价格", trigger: "blur"}]
        },
        //小程序负责人专用rules
        rules1: {
          service_content_types:[{required: true, message: "请选择小程序服务内容", trigger: "blur"}],
          goods_name: [
            {required: true, message: "请输入主办单位名称", trigger: "blur"}
          ],
          mainType: [
            {required: true, message: "请选择主体性质", trigger: "blur"}
          ],
          distructvalue: [
            {required: true, message: "请选择省市区", trigger: "blur"}
          ],
          address: [
            {required: true, message: "请输入通讯地址", trigger: "blur"}
          ],
          certificate_type: [
            {required: true, message: "请选择证件类型", trigger: "blur"}
          ],
          zt_certificate_type: [
            {required: true, message: "请选择证件类型", trigger: "blur"}
          ],
          fuze_certificate_number: [
            {required: true, message: "请选择证件号码", trigger: "blur"}
          ],
          certificate_number: [
            {required: true, message: "请输入证件号码", trigger: "blur"}
          ],
          certificate_address: [
            {required: true, message: "请输入证件住所", trigger: "blur"}
          ],
          certificate_photo: [
            {required: true, message: "请输入证件照片", trigger: "blur"}
          ],
          realname: [
            {required: true, message: "请输入姓名", trigger: "blur"}
          ],
          mobile: [
            {required: true, message: "请输入联系方式", trigger: "blur"}
          ],
          email: [
            {required: true, message: "请输入电子邮箱", trigger: "blur"}
          ],
          emergency_contact: [
            {required: true, message: "请输入应急联系方式", trigger: "blur"}
          ],
          finishtime: [
            {required: true, message: "请输入证件有效期", trigger: "blur"}
          ],
          certificate_photo_front: [
            {required: true, message: "请输入证件正面照片", trigger: "blur"}
          ],
          certificate_photo_back: [
            {required: true, message: "请输入证件背面照片", trigger: "blur"}
          ],
          album: [
            {required: true, message: "请上传产品图片", trigger: "change"}
          ],
          nrlx_type: [
            {required: true, message: "请选择前置审批类型", trigger: "change"}
          ],
          goods_detail: [
            {required: true, message: "请上传产品详情图片", trigger: "change"}
          ],
          unit: [{required: true, message: "请输入销售单位", trigger: "blur"}],
          goods_number: [
            {required: true, message: "请输入库存", trigger: "blur"}
          ],
          attr_cate: [
            {required: true, message: "请选择商品类目", trigger: "change"}
          ],      
          shop_price: [{required: true, message: "请输入价格", trigger: "blur"}],
          xcx_realname: [
            {required: true, message: "请输入姓名", trigger: "change"}
          ],  
          xcx_mobile: [
            {required: true, message: "请输入电话", trigger: "change"}
          ], 
          xcx_email: [
            {required: true, message: "请输入邮箱", trigger: "change"}
          ], 
          xcx_emergency_contact: [
            {required: true, message: "请输入应急联系方式", trigger: "change"}
          ], 
          xcx_certificate_type: [
            {required: true, message: "请选择类型", trigger: "change"}
          ], 
          xcx_fuze_certificate_number: [
            {required: true, message: "请输入证件号码", trigger: "change"}
          ], 
          xcx_finishtime: [
            {required: true, message: "请输入有效期", trigger: "change"}
          ], 
          xcx_certificate_photo_front: [
            {required: true, message: "请上传图片", trigger: "change"}
          ], 
          xcx_certificate_photo_back: [
            {required: true, message: "请上传图片", trigger: "change"}
          ], 
        },
        goodsType: null,
        drawer: false,    // 是否显示表单列表
        formList: [],     // 表单列表
        form_id: "",      // 选中的表单  
        form_name: "",    // 表单名称
        form_btn: "",     // 按钮名称
        loading: true, 
        page: {         
          pageindex: pagination.pageIndex,
          pagesize: pagination.pageSize,
          total: pagination.total
        },  
        promiseVideoFiled:'icp_materials.promise_video'
      };
    },
    created() {
      this.ispaysetshow();
      // 查询分类
      this.querycatelist();
      // 查询运费模板
      this.queryfreight();
      // 查询规格分类
      this.queryattrcatelist();
      // 查询主体性质
      this.queryMainProperty()
      // 查询证件类型
      this.queryCertificateType()
      // 查询省份信息
      this.queryDistrict()
      // 查询前置审批类型
      this.queryNrlxType()
      //获取小程序服务内容类型
      this.queryServerType()
      //获取人脸核身编码
      this.getTaskStatus()
       //获取详情内容
      this.getDetail()
      this.querydistribution();
      this.id = this.$route.query.id;
      this.goodsType = this.$route.query.type;
      if (this.id) {
        // let titleinfo = "编辑商品"
        // if(this.goodsType === 2){
        //   titleinfo = "复制商品"
        // }
        // this.titleinfo = titleinfo;
        // 查询详情
        // this.querydetail();
      }
    },
    methods: {
      getDetail(){
        this.axios
            .post(api.record_getApplyDetail, {})
            .then(response => {
              console.log(response.data,'responsedata')
              this.setFormdata(response.data)
            })
            .catch(response => {
            });
      },
      //附件处理
      setFileValue(data){
        //普通单个文件
        let fileArr = ['residence_permit','certificate_photo','certificate_photo_front','certificate_photo_back','authorization_letter','nrlx_media']
        fileArr.forEach(item=>{
          if(data[item] && data[item] != '' && data[item] != {}){
            this.formdata[item] = []
            this.formdata[item].push(data[item].fullpath)
            this.formdata[item+'media'] = data[item].media_id
          }
        })

         //附件数组 只能上传一个
         let fileArrMaxOne = ['holding_certificate_photo','website_construction_proposal','commitment_letter','business_name_change_letter','party_building_confirmation_letter',
        'promise_video','authenticity_responsibility_letter','authenticity_commitment_letter']
        fileArrMaxOne.forEach(item=>{
          if(data[item] && data[item] != '' && data[item] != []){
            this.formdata[item] = []
            this.formdata[item].push(data[item][0].fullpath)
            this.formdata[item+'media'] = data[item][0].media_id
          }
        })

         //附件数组可以上传多个
         let fileArrMaxMore = ['subject_other_materials','applets_other_materials']
         fileArrMaxMore.forEach(item=>{
          if(data[item] && data[item] != '' && data[item] != []){
            let fArr = []
            let fMedia = []
            data[item].forEach(fileItem => {
              fArr.push(fileItem.fullpath)
              fMedia.push(fileItem.media_id)
            })
            this.formdata[item] = fArr
            this.formdata[item+'media'] = fMedia
          }
        })
               //小程序负责人处理
               this.setSpecialValue(data)
        console.log('file',this.formdata)
      },
      //小程序负责人处理
      setSpecialValue(data){
         //判断小程序负责人是否和主体负责人是同一个
         if(data.realname && data.realname != '' && data.xcx_realname && data.xcx_realname != ''){
          if(data.realname != data.xcx_realname){
            this.radio = 2
            let xcxData = ['xcx_realname','xcx_mobile','xcx_fuze_certificate_number','xcx_certificate_type','xcx_email','xcx_emergency_contact']
            xcxData.forEach(item => {
              if(data[item] && data[item] != ''){
                this.formdata[item] = data[item]
              }
            })
           
            
            //文件
            let xcxfileArr = ['xcx_certificate_photo_front','xcx_certificate_photo_back','xcx_authorization_letter']
            xcxfileArr.forEach(item=>{
              if(data[item] && data[item] != '' && data[item] != {}){
                this.formdata[item] = []
                this.formdata[item].push(data[item].fullpath)
                this.formdata[item+'media'] = data[item].media_id
              }
            })

            //时间
            if(data.xcx_certificate_validity_date_start && data.xcx_certificate_validity_date_end){
              this.formdata.xcx_finishtime = []
              this.formdata.xcx_finishtime.push(data.xcx_certificate_validity_date_start)
              this.formdata.xcx_finishtime.push(data.xcx_certificate_validity_date_end)
            }
          }
        }
      },
      //普通字段处理
      setCommonValue(data){
        
         //附件处理
         this.setFileValue(data)
       
        let name = ['address','certificate_address','certificate_number','certificate_type','email','emergency_contact','fuze_certificate_number',
        'mobile','realname','zt_certificate_type','comment','nrlx_code','xcx_comment','nrlx_type']
        name.forEach(item=>{
          if(data[item] && data[item] != ''){
            this.formdata[item] = data[item]
          }
        })

          //主办单位名称
          if(data.name){
          this.formdata.goods_name = data.name
        }
        // //主体性质
        if(data.type && data.type != ''){
          this.formdata.mainType = Number(data.type)
        }
        if(data.service_content_types && data.service_content_types != []){
          this.formdata.service_content_types = data.service_content_types
        }
        //有效期
        if(data.certificate_validity_date_start && data.certificate_validity_date_end){
          this.formdata.finishtime = []
          this.formdata.finishtime.push(data.certificate_validity_date_start)
          this.formdata.finishtime.push(data.certificate_validity_date_end)
        }
        //省市区
        if(data.province && data.city && data.district){
          this.formdata.distructvalue = []
          this.formdata.distructvalue.push(Number(data.province))
          this.formdata.distructvalue.push(Number(data.city))
          this.formdata.distructvalue.push(Number(data.district))
          console.log(formdata.distructvalue,'formdata.distructvalue')
        }

      },
      setFormdata(data){
        
       
        //普通字段处理
        this.setCommonValue(data)
        
     
      },
      getTaskStatus(){
        this.axios
            .post(api.record_taskStatus, {})
            .then(response => {
              let {icpfiling_verify_result,apply_icpfiling_result,icp_task_id} = response.data
              this.icp_task_id = icp_task_id
            })
            .catch(response => {
            });
      },
      bindUpload(val){
        console.log('223343434',val)
      },
      //获取前置审批类型
      queryNrlxType() {
        let params = {};
        this.axios
            .post(api.record_nrlxType, params)
            .then(response => {
              if (response.data.errcode == 0) {
               
                this.nrlx_typeData = response.data.items || [];
              } else {
              }
            })
            .catch(response => {
            });
      },
        //获取小程序服务内容类型
        queryServerType() {
        let params = {};
        this.axios
            .post(api.record_serverType, params)
            .then(response => {
              if (response.data.errcode == 0) {
               
                this.server_typeData = response.data.items || [];
              } else {
              }
            })
            .catch(response => {
            });
      },
      // 查询主体性质
      queryMainProperty() {
        let params = {};
        this.axios
            .post(api.record_workProperty, params)
            .then(response => {
              if (response.data.errcode == 0) {
               
                this.mainTypeData = response.data.items || [];
              } else {
              }
            })
            .catch(response => {
            });
      },
        // 查询证件类型
      queryCertificateType() {
        let params = {};
        this.axios
            .post(api.record_certificateType, params)
            .then(response => {
              if (response.data.errcode == 0) {
               
                this.certificateData = response.data.items || [];
              } else {
              }
            })
            .catch(response => {
            });
      },
      //省份选择方法
      handleDistrictChange(e){
        console.log(e,'eeee')
        if(e.length > 0){
          this.formdata.province = e[0]
          this.formdata.city = e[1]
          this.formdata.district = e[2]
        }
      },
      // 查询省份信息
      queryDistrict() {
        let params = {};
        this.axios
            .post(api.record_districtCode, params)
            .then(response => {
              if (response.data.errcode == 0) {
                this.districtData = response.data.items || [];
              } else {
              }
            })
            .catch(response => {
            });
      },
      changetype() {
        this.formdata.cost = "";
        // this.formdata.shop_price = "";
      },
      // 删除多选分类
      removeTag(key) {
        let res = this.$refs.tree.getCheckedNodes();
        let ids = [];
        res.forEach((item, sindex) => {
          if (this.formdata.cat_label.indexOf(item.name) !== -1) {
            ids.push(item.id);
          }
        });
        this.formdata.cat_id = ids;
        this.$refs.tree.setCheckedKeys(ids);

      },
      getcheckedcate() {
        let catlabel = [];
        let catid = [];
        this.formdata.cat.forEach((item, sindex) => {
          if (this.formdata.cat_label === item.name) {
            index = sindex;
          }
        });
      },
      // 树型分类
      handleCheckChange() {
        let res = this.$refs.tree.getCheckedNodes();
        let arrLabel = [];
        let arr = [];
        res.forEach(item => {
          arrLabel.push(item.name);
          arr.push(item.id);
        });
        this.formdata.cat_id = arr;
        this.formdata.cat_label = arrLabel;
      },
      // 获取分销规则
      querydistribution() {
        let params = {};
        this.axios
            .post(api.goods_distribution, params)
            .then(response => {
              if (response.data.code == 0) {
                this.formdata.outside = response.data.info.comm_outside;
                this.formdata.inside = response.data.info.comm_inside;
              } else {
              }
            })
            .catch(response => {
            });
      },
      // 查询编辑详情
      querydetail() {
        let params = {
          goods_id: this.id
        };
        let apiHttp_ = api.goods_detail
        if(this.goodsType === 2){
          apiHttp_ = api.copy_goods
        }
        this.axios
            .post(apiHttp_, params)
            .then(response => {
              if (response.data.code == 0) {
                this.formdata.type = response.data.info.type;
                this.formdata.goods_name = response.data.info.goods_name;
                this.formdata.goods_number = response.data.info.goods_number;
                this.formdata.cat_id = response.data.info.cate_id;
                this.formdata.cat_label = response.data.info.cat_id;
                this.formdata.album = response.data.info.album || [];
                this.formdata.video = response.data.info.video;
                this.formdata.goods_detail = response.data.info.goods_detail || [];
                this.formdata.order_desc = response.data.info.order_desc;
                this.formdata.is_pay = response.data.info.is_pay;
                this.formdata.is_attr = response.data.info.is_attr;
                this.formdata.unit = response.data.info.unit;
                this.formdata.cost = response.data.info.cost;
                this.formdata.shop_price = response.data.info.shop_price;
                this.formdata.attr_cate = response.data.info.attr_cate;
                this.formdata.show_price = response.data.info.show_price + "";
                this.formdata.show_type = response.data.info.show_type;
                this.formdata.points = response.data.info.points;
                this.formdata.false_sales = response.data.info.false_sales;
                if (this.formdata.show_type === 0) {
                  this.formdata.reference1 = response.data.info.reference;
                  this.formdata.reference_price = response.data.info.reference_price;
                } else if (this.formdata.show_type === 1) {
                  this.formdata.reference2 = response.data.info.reference;
                }

                this.formdata.comm_type = response.data.info.comm_type;
                this.formdata.commission = response.data.info.commission;
                this.formdata.comm_set = response.data.info.comm_set;
                this.formdata.comm_outside = response.data.info.comm_outside;
                this.formdata.comm_inside = response.data.info.comm_inside;
                this.formdata.is_sale = response.data.info.is_sale;
				this.formdata.is_hot = response.data.info.is_hot;
				this.formdata.is_new = response.data.info.is_new;
				this.formdata.is_cheap = response.data.info.is_cheap;
				this.formdata.is_recommend = response.data.info.is_recommend;
                this.formdata.logistics_set = response.data.info.logistics_set;
                this.formdata.shipping_set = response.data.info.shipping_set;
                this.formdata.fre_id = response.data.info.fre_id;
                this.formdata.shipping_fee = response.data.info.shipping_fee;
                this.formdata.goods_brief = response.data.info.goods_brief;
                this.formdata.goods_desc = response.data.info.goods_desc;
                this.formdata.shipping_name =
                    response.data.info.shipping_name === 0 ? false : true;
                this.formdata.shipping_phone =
                    response.data.info.shipping_phone === 0 ? false : true;
                this.queryattrlist(
                    this.formdata.attr_cate,
                    this.getcheckattrids(response.data.attr)
                );
                this.createdittable(response.data.goods_attr);
              } else {
              }
            })
            .catch(response => {
            });
      },
      // 编辑规格表格数据
      createdittable(goodsattrlist) {
        let result = [];
        this.tablehead = [];
        goodsattrlist.forEach((gitem, gindex) => {
          let rowdata = {
            attr_number: gitem.number,
            attr_price: gitem.price,
            attr_points: gitem.points
          };
          if (gitem.attr_value && gitem.attr_value.length) {
            gitem.attr_value.forEach(aitem => {
              if (gindex === 0) {
                this.tablehead.push({
                  label: aitem.spec_name
                });
              }
              rowdata[aitem.spec_name] = {
                id: aitem.item_id,
                name: aitem.item_name,
                spec_id: aitem.spec_id
              };
            });
          }
          result.push(rowdata);
        });
        this.attrtable = result;
      },
      // 获取选中的规格id
      getcheckattrids(attr) {
        let ids = [];
        if (attr && attr.length) {
          attr.forEach(item => {
            ids.push(item.id);
          });
        }
        return ids;
      },
      // 查询分类
      querycatelist() {
        let params = {};
        this.axios
            .post(api.goods_goods_cate_list, params)
            .then(response => {
              if (response.data.code == 0) {
                this.cateoptions = response.data.list || [];
              } else {
              }
            })
            .catch(response => {
            });
      },
      // 多规格查询规格分类
      changeattr(val) {
        if (val === 1) {
          this.queryattrcatelist();
        }
      },
      // 查询规格分类列表
      queryattrcatelist() {
        let params = {};
        this.axios
            .post(api.goods_attr_cate_list, params)
            .then(response => {
              if (response.data.code == 0) {
                this.attrcateoptions = response.data.list || [];
              } else {
              }
            })
            .catch(response => {
            });
      },
      // 多规格查询规格分类列表
      changeattrcate(val) {
        if (val) {
          this.attrtable = [];
          this.tablehead = [];
          this.attr_price = "";
          this.attr_number = "";
          this.queryattrlist(val);
        }
      },
      // 规格名称列表
      queryattrlist(cateid, checkids) {
        let params = {
          cate_id: cateid
        };
        this.axios
            .post(api.goods_attr_list, params)
            .then(response => {
              if (response.data.code == 0) {
                this.attrinfo = this.transformattr(response.data.list, checkids);
              } else {
              }
            })
            .catch(response => {
            });
      },
      // 转换规格属性
      transformattr(list, checkids) {
        let res = [];
        if (list && list.length) {
          list.forEach(item => {
            let attritem = {
              name: item.name,
              attr: item.attr,
              checkattrList: []
            };
            let checkedattr = this.ischeckedattrid(item.attr, checkids);
            if (checkedattr.index !== -1) {
              attritem.checkattrList = [...checkedattr.ids];
            }
            res.push(attritem);
          });
        }
        return res;
      },
      // 是否存在选择的规格属性id
      ischeckedattrid(attr, checkids) {
        let result = {
          index: -1,
          ids: []
        };
        if (attr && attr.length) {
          attr.forEach((item, index) => {
            if (checkids && checkids.length && checkids.indexOf(item.id) !== -1) {
              result.ids.push(item.id);
              result.index = index;
            }
          });
        }
        return result;
      },
      // 获取规格属性列表
      getattrtable() {
        let result = [];
        this.tablehead = [];
        if (this.attrinfo) {
          this.attrinfo.forEach(attritem => {
            // 获取表头数据
            if (attritem.checkattrList.length) {
              this.tablehead.push({
                label: attritem.name
              });
            }
            // 获取选中属性数据
            let res = [];
            attritem.attr.forEach(item => {
              if (attritem.checkattrList.indexOf(item.id) !== -1) {
                let itemobj = {
                  attr_number: "",
                  attr_price: "",
                  attr_points: ""
                };             
                itemobj[attritem.name] = {
                  id: item.id,
                  name: item.name,
                  spec_id: item.spec_id
                };  
                res.push(itemobj);
              }
            });
            if (res && res.length) {
              if (this.attrtable.length > 0) {
                this.attrtable.forEach(item => {
                  res.forEach(itema => {
                    for (let i in item) {
                      if (i === "attr_number" || i === "attr_price" || i === "attr_points") {

                      } else {
                        for (let j in itema) {
                          if (i === j && item[i].name === itema[j].name) {
                            itema.attr_number = item.attr_number;
                            itema.attr_price = item.attr_price; 
                            itema.attr_points = item.attr_points; 
                          }
                        }

                      }
                    }
                  })
                })
              }
              result.push(res);
            }
          });
        }

        this.getattrtabledata(result);
      },
      // 应用价格
      handlePriceCommand(command) {
        this.settingattrtable(command, "p");
      },
      // 应用库存
      handleNumberCommand(command) {
        this.settingattrtable(command, "n");
      },
      // 应用积分
      handlePointCommand(command) {
        this.settingattrtable(command, "s");
      },
      // 设置规格售价，库存
      settingattrtable(val, type) {
        this.attrtable.forEach(row => {
          if (type == "p") {
            if (val === "a") {
              row.attr_price = this.attr_price;
            } else {
              if (row.attr_price === "") {
                row.attr_price = this.attr_price;
              }
            }
          }
          if (type == "n") {
            if (val === "a") {
              row.attr_number = this.attr_number;
            } else {
              if (row.attr_number === "") {
                row.attr_number = this.attr_number;
              }
            }
          }
          if (type == "s") {
            if (val === "a") {
              row.attr_points = this.attr_points;
            } else {
              if (row.attr_points === "") {
                row.attr_points = this.attr_points;
              }
            }
          }
        });
      },
      // 生成规格表格
      getattrtabledata(arr) {
        let result = [];
        let attr = this.attrtable;
        let thead = this.tablehead;
        arr.forEach(arritem => {      
          if (result.length == 0) {
            result = arritem;
          } else {      
            let emptyresult = [];
            result.forEach(item => {
              arritem.forEach(value => {
                let obj = {...item, ...value}
                if (item.attr_number) {obj.attr_number = item.attr_number};
                if (item.attr_price) {obj.attr_price = item.attr_price};
                if (item.attr_points) {obj.attr_points = item.attr_points};
                emptyresult.push(obj);
              });
            });
            result = emptyresult;
          }
        });
        this.attrtable = result;
      },
      // 产品图片
      detelFn(index) {
        this.formdata.album.splice(index, 1)
      },
      indexLine(index) {
        this.currentindex = index
      },
      datadragEnd(evt) {
        this.currentindex = evt.newIndex
      },
      getdata(data) {
      },
      imgAddBack(option) {
        this.formdata.album.push(option)
      },
      showCropper() {
        this.corppervisible = true
      },
      uploadalbum(val) {
        this.formdata.album = val;
      },
      // 产品详情
      uploaddetail(val) {
        this.formdata.goods_detail = val;
      },
      uploadresidence(val) {
        console.log('valvalval',val)
        this.formdata[val.filefname] = val.val;
      },
      uploadmediasucess(val) {
        //多个附件处理
        if(val.filefname == 'subject_other_materials'){
          this.formdata.subject_other_materialsmedia.push(val.media_id)
          return
        }
        if(val.filefname == 'applets_other_materials'){
          this.formdata.applets_other_materialsmedia.push(val.media_id)
          return
        }
        console.log('valvalval',val)
        this.formdata[val.filefname+'media'] = val.media_id;
        console.log(this.formdata,'this.formdata')
      },
      //多个附件删除附件
      deleteMediaUpload(val){
        this.formdata[val.filefname+'media'].splice(val.index, 1);
      },
      handlevideoSuccess(res, file) {
        if (res.code === 0) {
          this.formdata.video = res.path;
        } else {
          this.$message.error(res.msg);
        }
        this.loadingStatus.close();
      },
      handlepromise_videoSuccess(res, file) {
        if (res.code === 0) {
          this.formdata.promise_video = res.path;
        } else {
          this.$message.error(res.msg);
        }
        this.getIcpServer(res.path)
        this.loadingStatus.close();
      },
      getIcpServer(fullpath){
                let pathname = fullpath.split('/')
                let params = {
                    icp_order_field:this.promiseVideoFiled,
                    type:this.mediatype,
                    media:pathname[pathname.length-1],
                    // certificate_type:'',
                    fullpath:fullpath,
                    type:'video'
                }
                this.axios
                    .post(api.record_icpMediaType, params)
                    .then(response => {
                    if (response.data.errcode == 0) {
                        this.formdata.promise_videomedia = response.data.media_id;
                        this.loadingStatus.close();
                    } else {

                    }
                    })
                    .catch(response => {
                    });
            },
      getVideoIcpServer(filed,path){
        let that = this
          let params = {
              icp_order_field:filed,
              type:this.mediatype,
              media:path,
              certificate_type:2
          }
          this.axios
              .post(api.record_icpMediaType, params)
              .then(response => {
              if (response.data.errcode == 0) {
                that.loadingStatus.close();
              } else {
              }
              })
              .catch(response => {
              });
      },
      handlevideoRemove() {
        this.formdata.promise_video = ''
      },
      beforevideoUpload(file) {
        const isLt5M = file.size / 1024 / 1024 < 5;
        if (["video/mp4"].indexOf(file.type) == -1) {
          this.$message.error("请上传正确的视频格式");
          return false;
        }
        if (!isLt5M) {
          this.$message.error("上传视频大小不能超过5MB哦!");
          return false;
        }
        this.loadingStatus = this.$loading({
          lock: true,
          text: '上传中',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.4)',
          customClass: 'fontColor'
        });
      },
      // 查询运费模板
      queryfreight() {
        let params = {};
        this.axios
            .post(api.goods_freight, params)
            .then(response => {
              if (response.data.code == 0) {
                this.freoptions = response.data.list || [];
              } else {
              }
            })
            .catch(response => {
            });
      },
      getparams(){
        console.log(this.formdata,'this.formdata')
        let params = {
          type:this.formdata.mainType,   //主体性质
          name:this.formdata.goods_name,   //主办单位名称
          province:this.formdata.distructvalue[0],  //省份
          city:this.formdata.distructvalue[1],  //省份
          district:this.formdata.distructvalue[2],  //省份
          address:this.formdata.address,    //通讯地址
          comment:this.formdata.comment,    //主题信息备注
          xcx_comment:this.formdata.xcx_comment,   //小程序备注
          faren_certificate_number:this.formdata.faren_certificate_number,   //法人证件号码
          fuze_certificate_number:this.formdata.fuze_certificate_number,    //负责人证件号码
          realname:this.formdata.realname,    //主体人姓名

          xcx_comment:this.formdata.xcx_comment,  

        

          residence_permit:this.formdata.residence_permitmedia,  
          certificate_photo:this.formdata.certificate_photomedia,  
          certificate_photo_front:this.formdata.certificate_photo_frontmedia,  
          certificate_photo_back:this.formdata.certificate_photo_backmedia,  
         
          authorization_letter:this.formdata.authorization_lettermedia,  
          xcx_authorization_letter:this.formdata.xcx_authorization_lettermedia,  
          commitment_letter:this.formdata.commitment_lettermedia,  
          business_name_change_letter:this.formdata.business_name_change_lettermedia,  
          party_building_confirmation_letter:this.formdata.party_building_confirmation_lettermedia,  
          authenticity_responsibility_letter:this.formdata.authenticity_responsibility_lettermedia,  
          authenticity_commitment_letter:this.formdata.authenticity_commitment_lettermedia,  
          website_construction_proposal:this.formdata.website_construction_proposalmedia,  
          subject_other_materials:this.formdata.subject_other_materialsmedia.toString(','),  
          applets_other_materials:this.formdata.applets_other_materialsmedia.toString(','),    
          holding_certificate_photo:this.formdata.holding_certificate_photomedia,  
          nrlx_media:this.formdata.nrlx_mediamedia,  
          promise_video:this.formdata.promise_videomedia,

          // applets_other_materials:'3R7TFAi4a3UC5xMuu6zqdpdd5iTrKDDu6t5KJXFHe2HEuqsHp66PgxPY5HvDVywUysZwQCT',
          // commitment_letter:'3R7TFAi4a3UC5xMuu6zqdpdd5iTrKDDu6t5KJXFHe2HEuqsHp66PgxPY5HvDVywUysZwQCT',
          // business_name_change_letter:'3R7TFAi4a3UC5xMuu6zqdpdd5iTrKDDu6t5KJXFHe2HEuqsHp66PgxPY5HvDVywUysZwQCT',
          // party_building_confirmation_letter:'3R7TFAi4a3UC5xMuu6zqdpdd5iTrKDDu6t5KJXFHe2HEuqsHp66PgxPY5HvDVywUysZwQCT',
          // authenticity_responsibility_letter:'3R7TFAi4a3UC5xMuu6zqdpdd5iTrKDDu6t5KJXFHe2HEuqsHp66PgxPY5HvDVywUysZwQCT',
          // authenticity_commitment_letter:'3R7TFAi4a3UC5xMuu6zqdpdd5iTrKDDu6t5KJXFHe2HEuqsHp66PgxPY5HvDVywUysZwQCT',
          // website_construction_proposal:'3R7TFAi4a3UC5xMuu6zqdpdd5iTrKDDu6t5KJXFHe2HEuqsHp66PgxPY5HvDVywUysZwQCT',
          // subject_other_materials:'3R7TFAi4a3UC5xMuu6zqdpdd5iTrKDDu6t5KJXFHe2HEuqsHp66PgxPY5HvDVywUysZwQCT',
          // holding_certificate_photo:'3R7TFAi4a3UC5xMuu6zqdpdd5iTrKDDu6t5KJXFHe2HEuqsHp66PgxPY5HvDVywUysZwQCT',
          // promise_video:'3R7TFAi4a3UC5xMuu6zqdpdd5iTrKDDu6t5KJXFHe2HEuqsHp66PgxPY5HvDVywUysZwQCT',

          certificate_type:this.formdata.certificate_type,  //主体额外证件类型
          zt_certificate_type:this.formdata.zt_certificate_type,  //主体负责人证件类型
          certificate_number:this.formdata.certificate_number,  //证件号码
          certificate_address:this.formdata.certificate_address,   //证件住所
          nrlx_code:this.formdata.nrlx_code,   //前置审批号
          nrlx_type:this.formdata.nrlx_type,  //前置审批类型
          service_content_types:this.formdata.service_content_types.toString(','),  //小程序服务内容类型
          certificate_number:this.formdata.certificate_number,  //主题负责人姓名
          mobile:this.formdata.mobile,  //联系方式
          email:this.formdata.email,  //电子邮件
          emergency_contact:this.formdata.emergency_contact,  //应急联系方式
          // finishtime:this.formdata.finishtime,  //证件有效期
          certificate_validity_date_start:this.formdata.finishtime[0],  //证件有效期
          certificate_validity_date_end:this.formdata.finishtime[1],  //证件有效期
          // xcx_certificate_validity_date_start:this.formdata.xcx_finishtime[0],  //证件有效期
          // xcx_certificate_validity_date_end:this.formdata.xcx_finishtime[1],  //证件有效期
          //--
          verify_task_id:this.icp_task_id,  //扫脸认证任务
          xcx_verify_task_id:this.icp_task_id,
          faren_name:'',  //法人代表名称
        }
        if(this.radio == 1){
          params.xcx_realname=this.formdata.realname;  
          params.xcx_mobile=this.formdata.mobile;  
          params.xcx_email=this.formdata.email;  
          params.xcx_emergency_contact=this.formdata.emergency_contact;  
          params.xcx_certificate_type=this.formdata.certificate_type;  
          params.xcx_fuze_certificate_number=this.formdata.fuze_certificate_number;  
          params.xcx_certificate_photo_front=this.formdata.certificate_photo_frontmedia;  
          params.xcx_certificate_photo_back=this.formdata.certificate_photo_backmedia;  
          params.xcx_certificate_validity_date_start=this.formdata.finishtime[0];  //证件有效期
          params.xcx_certificate_validity_date_end=this.formdata.finishtime[1];  //证件有效期
        }else{
          params.xcx_realname=this.formdata.xcx_realname;  
          params.xcx_mobile=this.formdata.xcx_mobile;  
          params.xcx_email=this.formdata.xcx_email;  
          params.xcx_emergency_contact=this.formdata.xcx_emergency_contact;  
          params.xcx_certificate_type=this.formdata.xcx_certificate_type;  
          params.xcx_fuze_certificate_number=this.formdata.xcx_fuze_certificate_number;  
          params.xcx_certificate_photo_front=this.formdata.xcx_certificate_photo_frontmedia;  
          params.xcx_certificate_photo_back=this.formdata.xcx_certificate_photo_backmedia;  
          params.xcx_certificate_validity_date_start=this.formdata.xcx_finishtime[0];  //证件有效期
          params.xcx_certificate_validity_date_end=this.formdata.xcx_finishtime[1];  //证件有效期
        }
        console.log(params,'paramsparamsparams')
        return params;
      },
      top(){
        this.active--;
      },
      next(formName) {
        this.$refs[formName].validate(async valid => {
          if (valid) {
            if (this.active++ > 2) this.active = 0;
          }
        })
      },
      // 保存
      savegood(formName) {
        console.log(this.formdata,'formdata')
        this.$refs[formName].validate(async valid => {
          if (valid) {
            let params = {};
            params = this.getparams();

            // if (this.formdata.type === 1) {
            //   params = this.getvgoodparams();
            // }
            // if (this.formdata.type === 0) {
            //   params = this.getgoodparams();
            //   if (this.formdata.is_pay === 0 && this.formdata.is_attr === 1) {
            //     if (params.attr_data && params.attr_data.length === 0) {
            //       this.$message({
            //         message: "请选择商品类目项",
            //         type: "warning"
            //       });
            //       return false;
            //     } else {
            //       if (this.attremptycount > 0) {
            //         this.$message({
            //           message: "售价库存不能为空",
            //           type: "warning"
            //         });
            //         return false;
            //       }
            //     }
            //   }           
            // }
            // if (this.formdata.is_pay === 0 && this.formdata.type === 0) {
            //   let res = await this.ispayset();
            //   if (res.data.code == 0) {
            //     if (res.data.info.is_set === 0) {
            //       this.$message({
            //         type: "error",
            //         message: "线上支付商品需先配置微信支付"
            //       });
            //       return false;
            //     }
            //   }
            // }

            if (this.lock) {
              this.lock = false;
              if (this.id) {
                if (this.goodsType === 2) {
                  this.submitsave(params);
                } else {
                  this.submiteditsave(params);
                }
              } else {
                this.submitsave(params);
              }
            }
          } else {
            return false;
          }
        });
      },
      // 是否设置支付信息
      ispayset() {
        let params = {};
        return this.axios.post(api.companyadmin_company_pay, params);
      },
      // 是否显示配置标签
      async ispaysetshow() {
        let res = await this.ispayset();
        if (res.data.code == 0) {
          this.ispayshow = res.data.info.is_set === 0 ? true : false;
        }
      },
      // 虚拟商品
      getvgoodparams() {
        let params = {
          type: this.formdata.type,
          goods_name: this.formdata.goods_name,
          cat_id: this.formdata.cat_id,
          album: this.formdata.album.join(","),
          video: this.formdata.video,
          goods_detail: this.formdata.goods_detail.join(","),
          order_desc: this.formdata.order_desc,
          is_sale: this.formdata.is_sale,
		  is_hot: this.formdata.is_hot,
		  is_recommend: this.formdata.is_recommend,
		  is_cheap: this.formdata.is_cheap,
		  is_new: this.formdata.is_new,
          goods_brief: this.formdata.goods_brief,
          goods_desc: this.formdata.goods_desc
        };
        return params;
      },
      // 实体商品
      getgoodparams() {
        let params = {
          type: this.formdata.type,
          goods_name: this.formdata.goods_name,
          cat_id: this.formdata.cat_id,
          album: this.formdata.album.join(","),
          video: this.formdata.video,
          goods_detail: this.formdata.goods_detail.join(","),
          order_desc: this.formdata.order_desc,
          is_sale: this.formdata.is_sale,
          is_hot: this.formdata.is_hot,
          is_recommend: this.formdata.is_recommend,
          is_cheap: this.formdata.is_cheap,
          is_new: this.formdata.is_new,
          goods_brief: this.formdata.goods_brief,
          goods_desc: this.formdata.goods_desc,
          is_pay: this.formdata.is_pay
        };
        // 仅线上展示
        if (this.formdata.is_pay === 1) {
          params.show_type = this.formdata.show_type;
          if (this.formdata.show_type === 0) {
            params.reference = this.formdata.reference1;
            params.reference_price = this.formdata.reference_price;
          } else {
            params.reference = this.formdata.reference2;
            params.reference_price = "";
          }
        }
        // 支持线上支付
        if (this.formdata.is_pay === 0) {
          params.is_attr = this.formdata.is_attr;
          params.unit = this.formdata.unit;
          params.false_sales = this.formdata.false_sales;

          // 单规格
          if (this.formdata.is_attr === 0) {
            params.cost = this.formdata.cost;
            params.shop_price = this.formdata.shop_price;
            params.show_price = this.formdata.show_price;
            params.goods_number = this.formdata.goods_number;
            params.points = this.formdata.points;
          }
          // 多规格
          if (this.formdata.is_attr === 1) {
            params.attr_cate = this.formdata.attr_cate;
            params.cost = this.formdata.cost;
            params.attr_data = this.getattrsetting();
          }

          // 提成
          params.comm_type = this.formdata.comm_type;
          params.commission = this.formdata.commission;

          // 分销
          params.comm_set = this.formdata.comm_set;

          if (this.formdata.comm_set === 1) {
            params.comm_outside = this.formdata.comm_outside;
            params.comm_inside = this.formdata.comm_inside;
          }
          // 物流
          params.logistics_set = this.formdata.logistics_set;
          if (this.formdata.logistics_set === 0) {
            params.shipping_set = this.formdata.shipping_set;
            if (this.formdata.shipping_set === 0) {
              params.shipping_fee = this.formdata.shipping_fee;
              params.fre_id = "";
            }
            if (this.formdata.shipping_set === 1) {
              params.fre_id = this.formdata.fre_id;
              params.shipping_fee = "";
            }
          }
          if (this.formdata.logistics_set === 1) {
            params.shipping_name = this.formdata.shipping_name === true ? 1 : 0;
            params.shipping_phone = this.formdata.shipping_phone === true ? 1 : 0;
          }
        }
        return params;
      },

      // 多规格设置数据参数
      getattrsetting() {
        let result = [];
        this.attremptycount = 0;
        if (this.attrtable && this.attrtable.length > 0) {
          this.attrtable.forEach(item => {
            if (item.attr_price === "" || item.attr_number === "" || item.attr_number === "") {
              this.attremptycount++;
            }
            var setitem = {
              attr_price: item.attr_price,
              attr_number: item.attr_number,
              attr_points: item.attr_points
            };
            setitem.attr_value = {};
            if (this.tablehead && this.tablehead.length) {
              this.tablehead.forEach(hitem => {
                setitem.attr_value[item[hitem.label].spec_id] =
                    item[hitem.label].id;
              });
            }
            result.push(setitem);
          });
        }
        return result;
      },
      // 提交保存
      submitsave(params) {
        this.axios
            .post(api.record_applysumbit, params)
            .then(response => {
              this.lock = true;
              if (response.data.code == 0) {
                this.$message({
                  message: "保存成功",
                  type: "success"
                });
                this.goback();
              }else{
                let msgText = ''
                let msgData = response.data.msg.hints
                if(msgData && msgData.length > 0){
                  msgData.forEach(item=>{
                    msgText = msgText + item.errmsg + ';'
                    
                  })
                  this.msgText = msgText
                }
                console.log(response,'responseresponse111')
              }
            })
            .catch(response => {
              this.lock = true;
            });
      },
      // 提交保存
      submiteditsave(params) {
		  console.log(params,"params1440=*=*=**==**=*=*=*=**==**==*=*")
        // goodsType 1 编辑 2 复制商品
        let message_ = "保存成功"
        if (this.goodsType === 2) {
          message_ = "复制成功"
        }
        params.goods_id = this.id;
        this.axios
            .post(api.goods_edit, params)
            .then(response => {
              this.lock = true;
              if (response.data.code == 0) {
                this.$message({
                  message: message_,
                  type: "success"
                });
                this.goback();
              } 
            })
            .catch(response => {
              this.lock = true;
            });
      },
      goback() {
        this.$router.go(-1);
      },
      // 前往配置
      goset() {
        let routeData = this.$router.resolve({
          name: "payment"
        });
        window.open(routeData.href, "_blank");
      },
      // 前往运费模板
      createfreight() {
        let routeData = this.$router.resolve({
          name: "createFreight"
        });
        window.open(routeData.href, "_blank");
      },
      // 暂时注释，待接口调整后开启 
      // 弹出表单列表
      // openFormList() {
      //   this.drawer = true;
      //   this.getFormData();  
      // },
      // getFormData() {
      //   this.axios
      //     .post(api.companyadmin_form_list, {page: this.page.pageindex})
      //     .then(response => {
      //       if (response.data.code == 0) {
      //         this.formList = response.data.list;
      //         this.page.total = response.data.all_page;
      //       } 
      //     })
      //     .catch(() => {});        
      // },
      // selectForm(id, name) {
      //   this.form_id = id;
      //   this.form_name = name;
      // },
      // deleteForm() {
      //   this.form_id = "";
      //   this.form_name = "";
      // },
      // handleCurrentChange(val) {
      //   this.page.pageindex = val;
      //   this.getFormData();
      // },
      // handleClose() {
      //   this.drawer = false;
      // }
    }
  }
</script>
<style>
  .el-input{
    width: 300px;
  }
</style>